import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Confirmación de salida cuando hay cambios sin guardar.
 *
 * Devuelve true si el usuario decide salir igual, false si prefiere quedarse.
 */
@Component({
  selector: 'app-dialog-cambios-sin-guardar',
  templateUrl: './dialog-cambios-sin-guardar.component.html',
  styleUrls: ['./dialog-cambios-sin-guardar.component.css']
})
export class DialogCambiosSinGuardarComponent {

  constructor(private dialogRef: MatDialogRef<DialogCambiosSinGuardarComponent>) { }

  quedarse() {
    this.dialogRef.close(false)
  }

  salir() {
    this.dialogRef.close(true)
  }
}
